module.exports = __webpack_public_path__ + "assets/certificate_pdf/Adobe Illustrator CC_Silicon Stone Education_20170222.c769c1cf.pdf";